import { dew as _feeDew } from "../../errors/fee.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _estimateMaxPriorityFeePerGasDew } from "./estimateMaxPriorityFeePerGas.js";
import { dew as _getBlockDew } from "./getBlock.js";
import { dew as _getGasPriceDew } from "./getGasPrice.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.internal_estimateFeesPerGas = exports.estimateFeesPerGas = void 0;
  const fee_js_1 = _feeDew();
  const getAction_js_1 = _getActionDew();
  const estimateMaxPriorityFeePerGas_js_1 = _estimateMaxPriorityFeePerGasDew();
  const getBlock_js_1 = _getBlockDew();
  const getGasPrice_js_1 = _getGasPriceDew();
  async function estimateFeesPerGas(client, args) {
    return internal_estimateFeesPerGas(client, args);
  }
  exports.estimateFeesPerGas = estimateFeesPerGas;
  async function internal_estimateFeesPerGas(client, args) {
    const {
      block: block_,
      chain = client.chain,
      request,
      type = "eip1559"
    } = args || {};
    const baseFeeMultiplier = await (async () => {
      if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
        block: block_,
        client,
        request
      });
      return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new fee_js_1.BaseFeeScalarError();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = base => base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, getAction_js_1.getAction)(client, getBlock_js_1.getBlock, "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") return chain.fees.estimateFeesPerGas({
      block: block_,
      client,
      multiply,
      request,
      type
    });
    if (type === "eip1559") {
      if (typeof block.baseFeePerGas !== "bigint") throw new fee_js_1.Eip1559FeesNotSupportedError();
      const maxPriorityFeePerGas = request?.maxPriorityFeePerGas ? request.maxPriorityFeePerGas : await (0, estimateMaxPriorityFeePerGas_js_1.internal_estimateMaxPriorityFeePerGas)(client, {
        block,
        chain,
        request
      });
      const baseFeePerGas = multiply(block.baseFeePerGas);
      const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
      return {
        maxFeePerGas,
        maxPriorityFeePerGas
      };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, getAction_js_1.getAction)(client, getGasPrice_js_1.getGasPrice, "getGasPrice")({}));
    return {
      gasPrice
    };
  }
  exports.internal_estimateFeesPerGas = internal_estimateFeesPerGas;
  //# sourceMappingURL=estimateFeesPerGas.js.map
  return exports;
}